import useViewModel, { SelectUtilityViewModelProps } from './useViewModel'
import { FlowStep, Question, StatusButton } from 'app-components'
import { CardAction, CardActions, CardNavigation } from '@/components'
import UtilitySearchInput from 'features/utilities/UtilitySearchInput'

export default function SelectUtilityFlowStep(
  props: SelectUtilityViewModelProps,
) {
  const {
    onChange,
    onSubmit,
    selectedUtility,
    status: currentStatus,
    disabled,
  } = useViewModel(props)
  return (
    <FlowStep id="select-utlity-flow">
      <FlowStep.Content>
        <CardNavigation id="select-utility-card-navigation" />
        <Question
          title={'Who is your utility provider?'}
          subtitle={
            'Select your utility provider to integrate your exact electricity rates'
          }
        >
          <UtilitySearchInput
            selectedUtility={selectedUtility}
            onChange={onChange}
            label={'Select provider'}
          />
        </Question>
      </FlowStep.Content>

      <FlowStep.Actions>
        <CardActions>
          <CardAction type="primary">
            <StatusButton
              variant="primary"
              disabled={disabled}
              onClick={onSubmit}
              status={currentStatus}
              id="select-utility-card-select-button"
            >
              Next
            </StatusButton>
          </CardAction>
        </CardActions>
      </FlowStep.Actions>
    </FlowStep>
  )
}
